const actions = {
  FETCH: 'maintenance/FETCH',
  SET_STATE: 'maintenance/SET_STATE',
}

export default actions
